export const changeProjectConfirmText = 'Are you sure you want to change a project?';

export const changeProjectConfirmDescription = 'Changing the selected project will result in losing the data entered in the form.';
